import { render, staticRenderFns } from "./UiInfoBlock.vue?vue&type=template&id=511cb427"
import script from "./UiInfoBlock.vue?vue&type=script&lang=js"
export * from "./UiInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports